<template>
  <div>
    <template>
      <v-tabs
        v-model="tab"
        background-color="blue-grey lighten-1"
        centered
        dark
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-1">
          Dynamic
        </v-tab>

        <v-tab href="#tab-2">
          Static
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <CompanyDashboard />
        </v-tab-item>
        <v-tab-item value="tab-2">
          <CompanyDashboardStatic />
        </v-tab-item>
      </v-tabs-items>
    </template>
  </div>
</template>

<script>
import CompanyDashboard from "../components/CompanyDashboard2022";
import CompanyDashboardStatic from "../components/CompanyDashboardStatic2022";
import DefaultLayout from "@/layouts/DefaultLayout";

export default {
  name: "Company",
  created() {
    this.$emit(`update:layout`, DefaultLayout);
  },
  components: {
    CompanyDashboard,
    CompanyDashboardStatic
  },
  data() {
    return {
      tab: null
    };
  }
};
</script>
